export const routes = (prefix) => [
    {
        path: `/${prefix}/credit-control/create`,
        name: `${prefix}.credit-control.create`,
        component: () => import('./Form.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.credit-control.create`,
                PageDescription: "Accounts - Credit control",
            },
        },
    },
];
